module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/041-paraguay-c5fe9373be24ac23ec730962f897f139.svg";